export default "__VITE_ASSET__CibBG4cG__"